// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1HQ8O","tab":"Tabs_tab__1mH-N","tabActive":"Tabs_tabActive__1XtTr"};